import { useEffect } from "react";

export const useSignoutUser = () => {
  useEffect(() => {
    const deleteSessionAndRedirect = async () => {
      try {
        await fetch(`${process.env.REACT_APP_API_URL}/session`, {
          method: "DELETE",
          credentials: "include",
        });
      } catch (error) {
        // Continue with Auth0 logout even if app session deletion fails.
      }

      const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
      const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
      const auth0LogoutUrl = process.env.REACT_APP_AUTH0_LOGOUT_URL;

      if (!auth0Domain || !auth0ClientId || !auth0LogoutUrl) {
        return;
      }

      const params = new URLSearchParams({
        client_id: auth0ClientId,
        returnTo: auth0LogoutUrl,
      });

      window.location.replace(`${auth0Domain}/v2/logout?${params.toString()}`);
    };

    deleteSessionAndRedirect();
  }, []);
};
